import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDataset } from './tabular-type.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.sapBdc.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Mirror_SAP_BDC_Inbound_header),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Mirror_SAP_BDC_Inbound_header)
    ]
})
export class SapBdcDataset extends TabularTypeDataset {

    public static readonly MODEL: IModel;

    constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
